// 引用axios
import axios from 'axios'
import AppConfig from '@/config'
import { Message } from 'element-ui'
import { sessionTool, getCookie } from 'utils/util'

const configHeader = {
  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
}

export function getToken (config) {
  let token = {
    'token': getCookie('token')
  }
  config = Object.assign({}, config, token)
  return config
}

export function requestAsk (cls = 'http', dataCls = 'json', url, config = {}, options = {}, method) {
  url = (cls === 'https') ? (AppConfig.LOGIN_PATH + url) : (AppConfig.BASE_PATH + url)

  return axios({
    url,
    method: method || 'post',
    params: dataCls === 'query' ? config : null,
    data: dataCls !== 'query' ? config : null,
    headers: dataCls === 'form' ? configHeader : {},
    transformRequest: dataCls === 'form' ? [function (data) {
      let ret = ''
      for (let it in data) {
        ret += (encodeURIComponent(it) + '=' + encodeURIComponent(data[it])) + '&'
      }
      return ret.slice(0, ret.length - 1)
    }] : []
  }).then((res) => {
    return Promise.resolve(res.data)
  }).catch(error => {
    if (error.response) {
      switch (error.response.status) {
        case 500:
          Message({
            message: '500 ' + '服务器内部错误',
            type: 'error'
          })
          break
        case 401:
          Message({
            message: '401 ' + '访问资源未授权',
            type: 'error'
          })
          break
        case 404:
          Message({
            message: '404 ' + '访问的资源不存在',
            type: 'error'
          })
          break
        case 403:
          Message({
            message: '403 ' + '服务器拒绝了您的请求',
            type: 'error'
          })
          break
        case 400:
          Message({
            message: '400' + '服务器拒绝了您的请求',
            type: 'error'
          })
          break
        default:
          Message({
            message: error.message,
            type: 'error',
            duration: 5 * 1000
          })
          break
      }
    } else {
      console.log('Error', error.message)
    }
    console.log(error.config)
    return Promise.reject(error)
  })
}



// WEBPACK FOOTER //
// ./src/utils/baseRequest.js